export default {"src":"/_next/static/media/elix.5c8286dd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};